import React from "react";
import { FormatToCurrency } from "shared/helpers/MoneyHelpers";
import { Tooltip } from '@progress/kendo-react-tooltip';

function MoneyCell(props, options = null) {
  const isNegative = props.dataItem[props.field] < 0;
  let displayValue = props.dataItem[props.field];
  if (options && options.removeNegativeSymbol == true) {
    displayValue = Math.abs(displayValue);
  }
  const formattedNumber = FormatToCurrency(displayValue);
  let classCustomName = isNegative ? "negativeCurrency" : "positiveCurrency";
  if (props.tdProps) {
    classCustomName = props.tdProps.className + " " + classCustomName;
  }
  if (options && options.onClick) {
    return (
      <td
        {...props.tdProps}
        className={classCustomName}
        style={{ ...props.style }}
      >
        <a
          style={{
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={options.onClick}
        >
          {formattedNumber}
        </a>
      </td>
    );
  } else {
    return (
      <td
        {...props.tdProps}
        className={classCustomName}
        style={{ ...props.style }}
      >
        {formattedNumber}
      </td>
    );
  }
}

function AggregateMoneyFooterCell(props, options = null) {
  let displayAggregateValue = 0;
  let mainGridAggregates = null;
  if (options && options.aggregateData) {
    mainGridAggregates = options.aggregateData;
    if (mainGridAggregates[props.field]) {
      if (mainGridAggregates[props.field].sum !== null && mainGridAggregates[props.field].sum !== undefined) {
        displayAggregateValue = mainGridAggregates[props.field].sum;
      }
      else {
        displayAggregateValue = mainGridAggregates[props.field];
      }
    }
    else {
      displayAggregateValue = 0;
    }
  } else {
    throw new Error("No aggregate data provided");
  }

  const isNegative = displayAggregateValue < 0;
  const classCustomName =
    props.tdProps.className +
    " " +
    (isNegative ? "negativeCurrency" : "positiveCurrency");

  if (options && options.removeNegativeSymbol == true) {
    displayAggregateValue = Math.abs(displayAggregateValue);
  }
  const formattedNumber = FormatToCurrency(parseFloat(displayAggregateValue));

  if (options && options.onClick) {
    return (
      <td
        key={props.field + "-Aggregate"}
        className={classCustomName}
        style={{ ...props.style }}
      >
        <a
          style={{
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={options.onClick}
        >
          {formattedNumber}
        </a>
      </td>
    );
  } else {
    return (
      <td
        key={props.field + "-Aggregate"}
        className={classCustomName}
        style={{ ...props.style }}
      >
        {formattedNumber}
      </td>
    );
  }
}

function AggregateNumberFooterCell(props, options = null) {
  let displayAggregateValue = 0;
  let mainGridAggregates = null;
  if (options && options.aggregateData) {
    mainGridAggregates = options.aggregateData;
    if (mainGridAggregates[props.field]) {
      displayAggregateValue = mainGridAggregates[props.field].sum;
    }
  } else {
  }

  const classCustomName = props.tdProps.className;
  const formattedNumber = displayAggregateValue;
  if (options && options.onClick) {
    return (
      <td
        key={props.field + "-Aggregate"}
        // {...props.tdProps}
        className={classCustomName}
        style={{ ...props.style }}
      >
        <a
          style={{
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={options.onClick}
        >
          {formattedNumber}
        </a>
      </td>
    );
  } else {
    return (
      <td
        key={props.field + "-Aggregate"}
        // {...props.tdProps}
        className={classCustomName}
        style={{ ...props.style }}
      >
        {formattedNumber}
      </td>
    );
  }
}

function TooltipCell(props) {
  return (
    <Tooltip anchorElement="target" position="top">
      <span className="k-cell-inner" >
        <span className="k-link" onClick={props.onClick}>
          <span className="k-column-title" title={props.title}>
            {props.title}
            {props.children}
          </span></span>
      </span>
    </Tooltip>
  );
}

function TooltipCellWithOptions(props) {
  const options = props.options || {};
  const customToolTip = options.toolTip || props.title;
  return (
    <Tooltip anchorElement="target" position="top">
      <span className="k-cell-inner" >
        <span className="k-link" onClick={props.onClick}>
          <span className="k-column-title" title={customToolTip}>
            {props.title} {options.toolTip ? '*' : ''}
            {props.children}
          </span></span>
      </span>
    </Tooltip>
  );
}

export { MoneyCell, AggregateMoneyFooterCell, AggregateNumberFooterCell, TooltipCell, TooltipCellWithOptions };
